export default  {	
	data () {
		return { 
			active: 0,
			ultimoFin: null

		}
	},
	computed: {
		totalNomina()
		{
			let valorTotal=0

			for (let i = 0; i < this.dataForm.afiliado_nomina.nomina_devengados.length; i++) {		
				valorTotal=valorTotal+Math.round(this.dataForm.afiliado_nomina.nomina_devengados[i].valor)	
			}
			for (let i = 0; i < this.dataForm.afiliado_nomina.nomina_deducidos.length; i++) {
				valorTotal=valorTotal-Math.round(this.dataForm.afiliado_nomina.nomina_deducidos[i].valor)
			}

			this.updateDataForm({state: 'info_nomina/valor', data: valorTotal})

			return  valorTotal
		}
	},
	created () { 
		this.onInit()
	},
	destroyed()
	{
		this.limpiarAfiliado()
	},
	methods: {
		async onInit()
		{
			this.searchSw.value=''
			await this.resetDataForm()
			await this.updateDataForm({state:'info_nomina/fecha', data: this.fecha().fecha.minHoy})
		}
	}
}
